import { render, staticRenderFns } from "./comAdd.vue?vue&type=template&id=33988928&scoped=true"
import script from "./comAdd.vue?vue&type=script&lang=js"
export * from "./comAdd.vue?vue&type=script&lang=js"
import style0 from "./comAdd.vue?vue&type=style&index=0&id=33988928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33988928",
  null
  
)

export default component.exports